const updateLanguage = {
  'update-language-submitting-form': 'Sprache wird geändert. Bitte warten...',
  'update-language-submit-button': 'Sprache ändern',
  'update-language-title': 'In welcher Sprache möchten Sie den Newsletter erhalten?',
  'update-language-success-message': 'Die Sprache, in der Sie den Newsletter erhalten, wurde erfolgreich geändert'
};

export default updateLanguage;
